export default function TermsOfServiceRoute() {
	return (
		<div className="container mx-auto max-w-3xl py-16">
			<h1 className="text-h2 mb-8">Termeni și Condiții</h1>

			<div className="prose prose-slate dark:prose-invert max-w-none">
				<p className="text-muted-foreground">
					Ultima actualizare: Februarie 2026
				</p>

				<h2>1. Acceptarea termenilor</h2>
				<p>
					Prin utilizarea platformei Matematix, acceptați acești Termeni și
					Condiții. Dacă nu sunteți de acord, vă rugăm să nu utilizați serviciul.
				</p>

				<h2>2. Descrierea serviciului</h2>
				<p>
					Matematix este o platformă online de pregătire pentru Bacalaureat la
					Matematică, care oferă lecții, exerciții, recapitulări bazate pe
					repetiție spațiată și simulări de examen.
				</p>

				<h2>3. Contul de utilizator</h2>
				<ul>
					<li>
						Trebuie să furnizați informații corecte la înregistrare
					</li>
					<li>Sunteți responsabil de securitatea contului</li>
					<li>Nu partajați datele contului cu alte persoane</li>
				</ul>

				<h2>4. Utilizarea acceptabilă</h2>
				<p>Vă angajați să:</p>
				<ul>
					<li>Utilizați platforma doar în scopuri educaționale</li>
					<li>Nu copiați sau redistribuiți conținutul</li>
					<li>Nu încercați să accesați neautorizat sistemul</li>
				</ul>

				<h2>5. Proprietate intelectuală</h2>
				<p>
					Tot conținutul platformei (lecții, exerciții, design) este proprietatea
					Matematix și este protejat de drepturile de autor.
				</p>

				<h2>6. Plăți și abonamente</h2>
				<ul>
					<li>Planul gratuit oferă acces limitat la funcționalități</li>
					<li>Planul Premium este disponibil prin abonament lunar</li>
					<li>Puteți anula oricând din Portalul de facturare</li>
					<li>Rambursările se acordă conform politicii noastre</li>
				</ul>

				<h2>7. Limitarea răspunderii</h2>
				<p>
					Matematix oferă conținut educațional &ldquo;ca atare&rdquo;. Nu
					garantăm rezultate specifice la examen.
				</p>

				<h2>8. Modificări</h2>
				<p>
					Ne rezervăm dreptul de a modifica acești termeni. Utilizatorii vor fi
					notificați de modificările importante.
				</p>

				<h2>9. Legea aplicabilă</h2>
				<p>
					Acești termeni sunt guvernați de legislația din România.
				</p>

				<h2>10. Contact</h2>
				<p>
					Pentru întrebări, contactați-ne la{' '}
					<a href="mailto:contact@matematix.ro">contact@matematix.ro</a>.
				</p>
			</div>
		</div>
	)
}
